// @flow
import React from 'react'
import Note from '../note-redux'
import PayPalNote from '../note-redux-pp'
import PromotionLinks from '../promotion-links'
import { connect } from 'transfer/utils/p2p-connect'
import { getFlowType } from 'transfer/utils/url-utils'
import { changeNote, changeGiftOption } from 'transfer/actions/Actions'
import { changeThemeId } from 'transfer/actions/theme'
import ThemeBadge from '../theme-badge'
import NewThemeBadge from '../gift-options/new-theme-badge'
import { cacheFirstCardFirstFooterAndAllIcons } from '../../utils/cache-media-utils'
import { showGiftOptions } from '../../../experiments/gift-options'
import { isDw2Repaint } from '../../../experiments/dw2Repaint'
import { getExternalComponents } from '../../hooks'
import content from 'pp-react-l10n'
const showNewGiftOptions = showGiftOptions()

let i18n = content('transfer/inc/note')

const callAll = (...fns) => (...args) => fns.forEach(fn => fn && fn(...args))
type Props = {
  isGiftEligible: boolean,
  isNoteEditable: boolean,
  note: string,
  isReview: boolean,
  showENSubTextRTR: boolean,
  recipient: string,
  themeList?: [],
  themeId?: string,
  handleChangeNote: () => void,
  openThemeOverpanel: () => void,
  openNewThemeOverpanel: () => void,
  handleRemoveButton: () => void,
  onRemoveTheme: () => void,
  handleRemoveGiftOption: () => void,
  hasFetchedFundingOptions: boolean,
  isMgm: boolean,
  getExternalComponents: Function,
  isDonate: boolean,
  dispatch: Function,
  previewNoteLabel: string,
  isDonateButtonCampaigns: boolean,
}
class NoteWithGift extends React.Component<Props> {
  dom = React.createRef()

  componentDidMount() {
    const { isGiftEligible, themeList } = this.props
    if (isGiftEligible && themeList && themeList.length > 0) {
      cacheFirstCardFirstFooterAndAllIcons(this.props.themeList)
    }
  }

  render() {
    const {
      isGiftEligible,
      isNoteEditable,
      note,
      isMgm,
      themeList,
      themeId,
      handleChangeNote,
      openThemeOverpanel,
      isReview,
      openNewThemeOverpanel,
      handleRemoveButton,
      onRemoveTheme,
      handleRemoveGiftOption,
      showENSubTextRTR,
      isDonateButtonCampaigns,
    } = this.props

    const isFocused =
      this.dom.current === document.activeElement ||
      (this.dom.current &&
        this.dom.current.contains &&
        this.dom.current.contains(document.activeElement))

    const noteProps = {
      note: note,
      label: isDonateButtonCampaigns
        ? i18n('note.campaigns.label')
        : this.props.previewNoteLabel,
      disabled: !isNoteEditable,
      isReview: isReview,
      isDonate: this.props.isDonate,
      dispatch: this.props.dispatch,
      flowType: getFlowType(),
      recipient: this.props.recipient,
      showENSubTextRTR: showENSubTextRTR,
      handleChangeNote: handleChangeNote,
      hasFetchedFundingOptions: this.props.hasFetchedFundingOptions,
      hasGiftIcon: isGiftEligible && showGiftOptions,
    }

    return (
      <div
        ref={this.dom}
        // position: relative is necessary to place the gift icon correctly
        // in safari and chrome without having to modify line-height of the icons.
        style={{ position: 'relative' }}
      >
        {themeId && showNewGiftOptions && isGiftEligible && (
          <NewThemeBadge
            handleClick={openNewThemeOverpanel}
            selectedThemeId={themeId}
            handleRemoveButton={callAll(
              handleRemoveButton,
              onRemoveTheme,
              handleRemoveGiftOption
            )}
          />
        )}

        {isDw2Repaint() ? (
          <PayPalNote {...noteProps} />
        ) : (
          <Note {...noteProps} />
        )}

        {this.props.getExternalComponents('after:note')}

        {!isMgm && !showNewGiftOptions && (
          <PromotionLinks
            // if in weird cases themeList does not have what we want (e.g. service error resulting in empty array)
            // do not show gift
            shouldShowGift={isGiftEligible && themeList && themeList.length > 0}
            openGiftThemeOverpanel={openThemeOverpanel}
            themeHasBeenSelected={!!themeId}
            isNoteEditable={isNoteEditable}
            note={note}
            // highlight when focused
            highlightPromotions={isFocused}
          />
        )}
        {isGiftEligible && themeId && !showNewGiftOptions && (
          <ThemeBadge
            handleClick={openThemeOverpanel}
            selectedThemeId={themeId}
          />
        )}
      </div>
    )
  }
}

export default connect(
  ({ note, server, external, theme, transaction }) => ({
    note: note.note,
    isMgm: server.isMgm,
    isNoteEditable: server.env !== 'pisp' || external.notesEditable,
    themeList: theme.themeList,
    themeId: theme.themeId,
    hasFetchedFundingOptions: transaction.hasFetchedFundingOptions,
    getExternalComponents: getExternalComponents(server.env, 'note-with-gift'),
    isDonate: server.env === 'donate',
    isDonateButtonCampaigns: external.isDonateButtonCampaigns,
  }),
  dispatch => ({
    handleChangeNote: note => dispatch(changeNote(note)),
    handleRemoveButton: () => dispatch(changeThemeId('')),
    handleRemoveGiftOption: () => dispatch(changeGiftOption('')),
  })
)(NoteWithGift)
